import { Route, Routes } from "react-router-dom";
import AboutUs from "pages/aboutus";
import Home from "pages/home";
import HowItWorks from "pages/howitworks";
import ContactUs from "pages/contactus";
import Partner from "pages/partner";
import NotFound from "pages/notfound";
import PrivacyPolicypartners from "pages/Privacy policy for partners app/PrivacyPolicypartners";
import PrivacyPolicyUser from "pages/Privacy policy for user app/PrivacyPolicyUser";
import UserAgreement from "pages/UserAgreement/UserAgreement";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/howitworks" element={<HowItWorks />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/partner" element={<Partner />} />
      <Route path="/PrivacyPolicyForPartners" element={<PrivacyPolicypartners />} />
      <Route path="/PrivacyPolicyForUser" element={<PrivacyPolicyUser />} />
      <Route path="/UserAgreement" element={<UserAgreement />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
